@if (isUserUnAuthorized) {
  <app-un-authorized [errorStatusCode]="errorStatusCode"></app-un-authorized>
} @else {
  @if (weavyData) {
    <app-notification-settings [name]="docType" [isMobile]="weavyData?.isMobileScreen"></app-notification-settings>
  }
  <div class="{{weavyData?.isMobileScreen ? 'mobile-view' : ''}}">
    <div class="doc-actions" [ngClass]="{ 'no-padding': weavyData?.isIhubScreen }">
      @if (!isApplicationRunningOnOnItSystem && !weavyData?.isMobileScreen) {
        @if (docType != 'policy') {
          <button class="doc-actions-button-container" (click)="downloadPosts()"
            [matTooltip]="weavyData?.isIhubScreen ? 'Download Posts' : ''">
            <img [src]="'images/pdf-dw.svg' | assetUrl" alt="pdf" class="icon-mr-5" />
            <span [hidden]="weavyData?.isIhubScreen && !ihubMaximizeFlag" class="download-posts-button-container-title">Download
            Posts</span>
          </button>
        }
        <button class="doc-actions-button-container" (click)="downloadPostsAndPolicyDocs()"
          [matTooltip]="weavyData?.isIhubScreen ? 'Download All' : ''">
          <img [src]="'images/folder-download.svg' | assetUrl" alt="pdf" class="icon-mr-5" />
          <span [hidden]="weavyData?.isIhubScreen && !ihubMaximizeFlag" class="download-posts-button-container-title">{{
            weavyData?.isIhubScreen
            ? "Download All"
            : "Download Policy Docs & Posts"
          }}</span>
        </button>
      }
      @if (!weavyData?.isMobileScreen) {
        <button class="doc-actions-button-container" (click)="handleDocumentRefresh()"
          [matTooltip]="weavyData?.isIhubScreen ? 'Refresh' : ''">
          <img alt="refresh" [src]="'images/refresh.svg' | assetUrl" class="icon-mr-5" />
          <span [hidden]="(weavyData?.isIhubScreen && !ihubMaximizeFlag)" class="title">Refresh</span>
        </button>
      }
      <button class="doc-actions-button-container" (click)="notificationSettings()"
        [matTooltip]="weavyData?.isIhubScreen ? 'Notification Settings' : ''">
        <img alt="settings" [src]="'images/settings.svg' | assetUrl" class="icon-mr-5" />
        <span [hidden]="(weavyData?.isIhubScreen && !ihubMaximizeFlag) || weavyData?.isMobileScreen" class="title">Notification Settings</span>
      </button>
    </div>
    @if (!disableDragAndDrop) {
      <div class="referral-documents-container" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
        (drop)="onFileDrop($event)" [ngClass]="{ 'drag-over': draggedOver, 'height-auto': weavyData?.isMobileScreen}">
        @if (draggedOver) {
          <div class="drag-text">Drop files here.</div>
        }
        <div class="folder-header">
          <div class="folder-name display-name folder-display-name">
            <span (click)="resetBreadCrumb()" (keypress)="resetBreadCrumb()" class="cursor-pointer" [matTooltip]="displayName">
              <img alt="folder" [src]="'images/folder_open.svg' | assetUrl" class="yellow-icon" draggable="false" />
              <span>{{displayName}}</span>
            </span>
            @if(breadcrumb?.length) { @for (item of breadcrumb; track item.id) {
              <img alt="right" [src]="'images/chevron_right.svg' | assetUrl" class="chevron" draggable="false" />
              <span [matTooltip]="item.name" class="breadcrumb-item cursor-pointer" (click)="navigateBreadcrumb(item)" (keypress)="navigateBreadcrumb(item)">
                {{ item.name }}
              </span>
              } }
            </div>
            <div class="folder-actions">
              <span class="hover-black" (click)="toggleView()">
                @if (tableView) {
                  <img alt="module view" [src]="'images/module_view.svg' | assetUrl" draggable="false" />
                }
                @if (!tableView) {
                  <img alt="table view" [src]="'images/table_view.svg' | assetUrl" draggable="false" />
                }
              </span>
              @if (!weavyData?.isMobileScreen) {
                <span [matMenuTriggerFor]="appActionsMenu" class="hover-black"
                  overlapTrigger="true">
                  <img [src]="'images/more.svg' | assetUrl" alt="pin icon" draggable="false" />
                </span>
              }
              <mat-menu #appActionsMenu="matMenu" class="actions-menu" xPosition="before">
                @for (item of appActionsList; track item) {
                  <button class="mat-menu-item-button" mat-menu-item (click)="view(item, true)">
                    @if (item?.icon) {
                      <mat-icon [class]="item.menuItemClasses">{{
                        item.icon
                      }}</mat-icon>
                    }
                    @if (item?.imgUrl) {
                      <img [src]="'images/' + item.imgUrl + '.svg' | assetUrl" alt="{{ item.imgUrl }} icon"
                        [class]="item.menuItemClasses" draggable="false" />
                    }
                    {{ item.displayName }}
                  </button>
                }
              </mat-menu>
            </div>
          </div>
          @if (showProgress) {
            <div style="width: 100%" class="progress-bar-container">
              <mat-progress-bar mode="determinate" [value]="progressVal" class="custom-progress-bar"
              [ngClass]="{ 'custom-progress-bar-striped': progressVal >= 100 }"></mat-progress-bar>
            </div>
          }
          @if (showLoader) {
            <collaboration-ui-spinner [overlay]="true"></collaboration-ui-spinner>
          }
          <div class="table-container">
            @if (tableView) {
              <table mat-table [dataSource]="dataSource" class="folder-table">
                <ng-container matColumnDef="doc">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <img (click)="getDocumentBlob(element)" (keypress)="getDocumentBlob(element)" draggable="false"
                      [src]="('images/' + (imageMapper?.[element.fileExtension] ? imageMapper?.[element.fileExtension] : 'file') + '.svg')  | assetUrl"
                      alt="document icon" />
                    </td>
                  </ng-container>
                  @for (col of colRef.slice(1, colRef.length - 1); track col) {
                    <ng-container [matColumnDef]="col">
                      <th mat-header-cell *matHeaderCellDef>
                        {{ col | uppercase }}
            <span class="hover-black sort-icon" [class.current-sort-column]="
                columnMapper[col] === sortOrderDetail.filedName
              " (click)="sortTableData(col)" (keypress)="sortTableData(col)">
                          @if(columnMapper[col] === sortOrderDetail.filedName &&
                            sortOrderDetail.sortOrder === 'asc') {
                            <img [src]="'images/sort-asc.svg' | assetUrl" alt="sort column" draggable="false" />
                          } @else if (columnMapper[col] === sortOrderDetail.filedName &&
                            sortOrderDetail.sortOrder === 'desc') {
                            <img [src]="'images/sort-desc.svg' | assetUrl" alt="sort column" draggable="false" />
                          } @else {
                            <img [src]="'images/sort.svg' | assetUrl" alt="sort column" draggable="false" />
                          }
                        </span>
                      </th>
                      <td mat-cell *matCellDef="let element" class="name-overflow"
                        [ngStyle]="{'max-width': weavyData?.isMobileScreen ? '100px' : '340px'}">
                        @if (
                          col === 'name' &&
                          (element.fileExtension.includes('doc') ||
                          element.fileExtension.includes('ppt') ||
                          (element.fileExtension.includes('xls') && !['xlsm', 'xlx'].includes(element.fileExtension)) ||
                          element.kind === 'image' ||
                          element.fileExtension === 'pdf' ||
                          element.fileExtension === 'txt' ||
                          element.fileExtension === 'csv' ||
                          element.fileExtension === 'msg')) {
                          <a class="doc-link module-item" [matTooltip]="element[col]">{{
                            element[col]
                          }}</a>
                        } @else {
                          @switch (col) { @case ('name') {
                            <span [ngClass]="{ 'doc-link': element['kind'] === 'note' }" [matTooltip]="element['fileName']">
                            {{ element["fileName"] }}</span>
                            } @case ('type') {
                            <span>{{ element["kind"] }}</span>
                            } @case ('date') {
                            <span>{{
                              (element["modifiedAt"]
                              ? element["modifiedAt"]
                              : element["createdAt"]) + "Z" | date : "short"
                            }}</span>
                            } @case ('size') {
                            <span>{{ element["blobSize"] | size }}</span>
                            } @default {
                            <span>{{ element[col] }}</span>
                            } }
                          }
                        </td>
                      </ng-container>
                    }
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let element; let i = index">
                        <span [matMenuTriggerFor]="actionsMenu" (click)="openActions(i, element, $event)" (keypress)="openActions(i, element, $event)" class="hover-black"
                          overlapTrigger="true">
                          <img [src]="'images/more.svg' | assetUrl" alt="pin icon" draggable="false" />
                        </span>
                      </td>
                      <mat-menu #actionsMenu="matMenu" class="actions-menu" xPosition="before">
                        @for (item of menuItem?.list; track item) {
                          <button class="mat-menu-item-button" mat-menu-item (click)="view(item)"
                            [ngClass]="{ 'action-border-botton': item?.name === 'details' && menuItem?.list.length > 2}">
                            @if (item?.icon) {
                              <mat-icon [class]="item.menuItemClasses">{{
                                item.icon
                              }}</mat-icon>
                            }
                            @if (item?.imgUrl) {
                              <img [src]="'images/' + item.imgUrl + '.svg' | assetUrl"
                                alt="{{ item.imgUrl }} icon" [class]="item.menuItemClasses" draggable="false" />
                            }
                            {{ item.displayName }}
                          </button>
                        }
                      </mat-menu>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="colRef"></tr>
                    <tr mat-row *matRowDef="let row; columns: colRef" (click)="handleRowClick(row)" (keypress)="handleRowClick(row)" class="cursor-pointer"></tr>
                  </table>
                } @else {
                  <div class="content-cards">
                    @for (item of dataSource.data; track item; let i = $index) {
                      <mat-card class="card cursor-pointer" appearance="outlined"
                        (click)="handleModuleRowClick(item)" (keypress)="handleModuleRowClick(item)" [ngClass]="{'thin-border': weavyData?.isMobileScreen}">
                        <div class="image-container">
                          <img draggable="false"
                            [src]="('images/' + (imageMapper?.[item.fileExtension] ? imageMapper?.[item.fileExtension] : 'file') + '.svg')  | assetUrl"
                            alt="document icon" />
                          </div>
                          <mat-card-actions class="footer">
            <span [ngClass]="{
                'module-item':
                  item.fileExtension.includes('doc') ||
                  item.fileExtension.includes('ppt') ||
                  (item.fileExtension.includes('xls') && !['xlsm', 'xlx'].includes(item.fileExtension)) ||
                  item.kind === 'image' ||
                  item.fileExtension === 'pdf' ||
                  item.fileExtension === 'txt' ||
                  item.fileExtension === 'csv' ||
                  item.fileExtension === 'msg'
              }" [title]="item.name">{{ item.name }}</span>
                            <button mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="openActions(i, item, $event)"
                              class="hover-black">
                              <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #actionsMenu="matMenu" class="actions-menu" xPosition="before">
                              @for (item of menuItem?.list; track item) {
                <button class="mat-menu-item-button" mat-menu-item (click)="view(item)" [ngClass]="{
                    'action-border-botton': item?.name === 'details'
                  }">
                                  @if (item?.icon) {
                                    <mat-icon [class]="item.menuItemClasses">{{
                                      item.icon
                                    }}</mat-icon>
                                  }
                                  @if (item?.imgUrl) {
                                    <img [src]="'images/' + item.imgUrl + '.svg' | assetUrl"
                                      alt="{{ item.imgUrl }} icon" [class]="item.menuItemClasses" draggable="false" />
                                  }
                                  {{ item.displayName }}
                                </button>
                              }
                            </mat-menu>
                          </mat-card-actions>
                        </mat-card>
                      }
                    </div>
                  }
                  @if ((noData | async) && !isLoading) {
                    <div class="no-records" [ngClass]="{ 'small-font-size': weavyData?.isMobileScreen }">
                      Nothing in this folder yet. Go ahead and add some files!
                    </div>
                  }
                </div>
                @if (!weavyData?.isMobileScreen) {
                  <div class="upload-container">
                    <div class="upload-fab">
                      <button mat-fab aria-label="upload document" [matMenuTriggerFor]="uploadMenu">
                        <img [src]="'images/paperclip_horizontal.svg' | assetUrl" alt="upload icon" draggable="false" />
                      </button>
                      <mat-menu #uploadMenu="matMenu" class="upload-fab-panel" xPosition="before">
                        <input #fileUpload id="fileUpload" multiple (change)="onFileChange($any($event)?.target?.files)" type="file" />
                        <button class="mat-menu-item-button" mat-menu-item>
                          <label for="fileUpload">
                            <img [src]="'images/computer.svg' | assetUrl" alt="your computer icon" class="icon-mr-5"
                              draggable="false" />
                              Your computer
                            </label>
                          </button>
                        </mat-menu>
                      </div>
                      <div class="create-fab">
                        <button mat-fab class="create-document" [class.create-file-inactive]="!fileCreateMenuOpened"
                          [class.create-file-active]="fileCreateMenuOpened" aria-label="create document" [matMenuTriggerFor]="filesMenu"
                          (click)="toggleFileCreateMenu()">
                          <img alt="plus" [src]="'images/plus.svg' | assetUrl" class="cursor-pointer plus-icon" draggable="false" />
                        </button>
                        <mat-menu #filesMenu="matMenu" (closed)="onBackdropClick()" class="file-upload-fab-panel" xPosition="before">
                          <button class="mat-menu-item-button" mat-menu-item (click)="createFolder('folder')">
                            <label for="fileUpload">
                              <img [src]="'images/folder.svg' | assetUrl" alt="your computer icon" class="icon-pr-5" draggable="false" />
                              Folder
                            </label>
                          </button>
                          <button mat-menu-item (click)="createNote()">
                            <label for="fileUpload">
                              <img [src]="'images/file_document.svg' | assetUrl" alt="your computer icon" class="icon-pr-5"
                                draggable="false" />
                                Note
                              </label>
                            </button>
                            <!-- <button mat-menu-item [matMenuTriggerFor]="officeMenu">
                            <label for="fileUpload">
                              <img [src]="'images/office.svg' | assetUrl" alt="your computer icon" class="icon-pr-5" draggable="false" />
                              Office
                              <i class="fa-solid fa-chevron-right office-icon" (click)="toggleOfficeOptions($event)"></i>
                            </label>
                          </button> -->
                        </mat-menu>
                        <mat-menu #officeMenu="matMenu" class="office-fab-panel" xPosition="before">
                          <button class="mat-menu-item-button" mat-menu-item (click)="createFolder('docx')">
                            <label for="fileUpload">
                              <img [src]="'images/word.svg' | assetUrl" alt="your computer icon" class="icon-pr-5" draggable="false" />
                              Word
                            </label>
                          </button>
                          <button mat-menu-item (click)="createFolder('xlsx')">
                            <label for="fileUpload">
                              <img [src]="'images/excel.svg' | assetUrl" alt="your computer icon" class="icon-pr-5" draggable="false" />
                              Excel
                            </label>
                          </button>
                          <button mat-menu-item (click)="createFolder('pptx')">
                            <label for="fileUpload">
                              <img [src]="'images/ppt.svg' | assetUrl" alt="your computer icon" class="icon-pr-5" draggable="false" />
                              Powerpoint
                            </label>
                          </button>
                        </mat-menu>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>

            <collaboration-ui-doc-viewer [document]="previewElement" [isMobileScreen]="weavyData?.isMobileScreen"
              (onPreviewClose)="onPreviewClose()">
            </collaboration-ui-doc-viewer>
          }